/* sc-passwort.js — nur eine Aufgabe.
   Die Einwilligung der Warteliste verlinkt auf #sc-datenschutz, den Ausklapper mit der
   Datenschutzerklaerung weiter unten auf derselben Seite. Ein Anker springt dorthin, oeffnet
   ein <details> aber nicht von selbst. Ohne das hier muesste man nach dem Klick noch einmal
   auf "Datenschutz" tippen — bei einer Pflicht-Einwilligung ist das eine Huerde zu viel.
   Ohne JavaScript bleibt alles bedienbar: der Sprung funktioniert, man klappt selbst auf. */
(function () {
  function oeffne(id) {
    var el = id && document.getElementById(id.replace(/^#/, ''));
    if (el && el.tagName === 'DETAILS' && !el.open) {
      el.open = true;
      el.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (a) oeffne(a.getAttribute('href'));
  });
  if (location.hash) oeffne(location.hash);
})();
